@import "../../themes/stories.globals";
@import "../grid/grid.mixins";

// Grid Column
// --------------------------------------------------

/// @prop - The padding for the grid column
$grid-column-padding:        var(--stories-grid-column-padding, 5px) !default;

/// @prop - The padding for the column at different breakpoints
$grid-column-paddings: (
  xs: var(--stories-grid-column-padding-xs, $grid-column-padding),
  sm: var(--stories-grid-column-padding-sm, $grid-column-padding),
  md: var(--stories-grid-column-padding-md, $grid-column-padding),
  lg: var(--stories-grid-column-padding-lg, $grid-column-padding),
  xl: var(--stories-grid-column-padding-xl, $grid-column-padding)
) !default;

// Column
// --------------------------------------------------

:host {
  /**
   * @prop --stories-grid-columns: The number of total Columns in the Grid
   * @prop --stories-grid-column-padding: Padding for the Column
   * @prop --stories-grid-column-padding-xs: Padding for the Column on xs screens and up
   * @prop --stories-grid-column-padding-sm: Padding for the Column on sm screens and up
   * @prop --stories-grid-column-padding-md: Padding for the Column on md screens and up
   * @prop --stories-grid-column-padding-lg: Padding for the Column on lg screens and up
   * @prop --stories-grid-column-padding-xl: Padding for the Column on xl screens and up
   */
  @include make-breakpoint-padding($grid-column-paddings);
  @include margin(0);

  box-sizing: border-box;

  position: relative;

  flex-basis: 0;
  flex-grow: 1;

  width: 100%;
  max-width: 100%;
  min-height: 1px; // Prevent columns from collapsing when empty
}
